import React from 'react'
import styles from './Surface.module.scss'

type Variant = 'card' | 'panel' | 'flat'
type Radius = 'none' | 'sm' | 'md' | 'lg'

interface SurfaceProps {
  children: React.ReactNode
  variant?: Variant
  radius?: Radius
  padding?: boolean
  className?: never
}

const variantMap: Record<Variant, string> = {
  card: styles.card, panel: styles.panel, flat: styles.flat,
}

const radiusMap: Record<Radius, string> = {
  none: styles.radiusNone, sm: styles.radiusSm, md: styles.radiusMd, lg: styles.radiusLg,
}

export const Surface: React.FC<SurfaceProps> = ({
  children, variant = 'card', radius = 'lg', padding = false,
}) => (
  <div className={[variantMap[variant], radiusMap[radius], padding ? styles.padded : ''].join(' ')}>
    {children}
  </div>
)
